import React, {Component} from 'react'
import {SimpleFilterStyle} from './../styles'
import {NavLink} from 'react-router-dom'

export default class SimpleFilter extends Component {

  render () {
    const {filters, parentPath} = this.props
    return (
      <ul className={`simple-filter ${SimpleFilterStyle} reset flex`}>
        {
          filters && filters.map((filter, index) => (
            <li key={index} className='simple-filter-item'> 
              <NavLink to={`${parentPath}/${ index > 0 ? filter.slug : ''}`} exact >
                {
                  filter.icon && filter.icon
                }
                <span>  {filter.label} </span> 
              </NavLink>
            </li>
          ))
        }
      </ul>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SimpleFilter.js